const categories = [
    {
        "name": "Others",
        "value": "OTHERS"
    },
    {
        "name": "Service",
        "value": "SERVICE"
    },
    {
        "name": "Vegetables",
        "value": "VEGETABLES"
    },
    {
        "name": "Fruits",
        "value": "FRUITS"
    },
    {
        "name": "Dry Fruits",
        "value": "DRY_FRUITS"
    },
    {
        "name": "Food Grains",
        "value": "FOOD_GRAIN"
    },
    {
        "name": "Pulses",
        "value": "PULSES"
    },
    {
        "name": "Processed Items",
        "value": "PROCESSED_ITEMS"
    },
    {
        "name": "Spices",
        "value": "SPICES"
    },
    {
        "name": "Dairy",
        "value": "DAIRY"
    },
    {
        "name": "Edible Oils",
        "value": "EDIBLE_OILS"
    },
    {
        "name": "Salt Sugar Jaggery",
        "value": "SALT_SUGAR_JAGGERY"
    },
    {
        "name": "Beverages",
        "value": "BEVERAGES"
    },
    {
        "name": "Exotic",
        "value": "EXOTIC"
    },
    {
        "name": "Non Veg",
        "value": "NON_VEG"
    },
    {
        "name": "Hive Products",
        "value": "HIVE_PRODUCTS"
    },
    {
        "name": "Animal Husbandry",
        "value": "Animal_Husbandry"
    },
    {
        "name": "Old",
        "value": "OLD"
    }
];

export default categories;